import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({
      id: 'settings.rmAccount.view.resetApiKeyModal.header.title',
    }),
    subtitle: translate({
      id: 'settings.rmAccount.view.resetApiKeyModal.header.subtitle',
    }),
  }))

  return api
}
